/* eslint-disable no-undef */
(function (root, factory) {
  if (typeof define === "function" && define.amd) {
    define(factory);
  } else if (typeof exports === "object") {
    module.exports = root.sma = factory();
  } else {
    root.sma = factory();
  }
})(typeof self !== "undefined" ? self : this, function () {
  /**
   * 平台校验
   * @method platform
   * @return {Object}
   * @private
   */
  var platform = (function () {
    var ua = navigator.userAgent.toLowerCase(),
      sys = {};

    ua.indexOf("android") > -1 || ua.indexOf("adr") > -1
      ? (sys.android = true)
      : ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
      ? (sys.ios = true)
      : {};

    return sys;
  })();

  /**
   * APP 校验
   * @method platform
   * @return {Object}
   * @private
   */
  var isApp = (function () {
    var ua = navigator.userAgent.toLowerCase();
    var sys = {};
    var s = null;

    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      sys.wechat = true;
      return sys;
    }

    s = ua.match(/scimall\/([\d.]+)/);
    if (s) {
      sys.scimall = s[1];
      return sys;
    }

    s = ua.match(/innovationchina\/([\d.]+)/);
    if (s) {
      sys.innovationChina = s[1];
      return sys;
    }

    s = ua.match(/sciencechina\/([\d.]+)/);
    if (s) {
      sys.scienceChina = s[1];
      return sys;
    }
  })();

  /**
   * 同步获取信息
   * @method  sendSyncMessage
   * @param {Object} params 属性的名称/值 {}
   * @return {Object}
   * @private
   */
  function sendSyncMessage(params) {
    var result = prompt(JSON.stringify(params));

    return result ? JSON.parse(result) : {};
  }

  /**
   * 异步获取信息
   * @method  sendMessage
   * @param {Object} params 属性的名称/值
   * @return {Object}
   * @private
   */
  function sendMessage(params) {
    window.webkit.messageHandlers.ScimallWKJavascriptBridge.postMessage(params);
  }

  function extend(target, obj) {
    for (var item in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, item)) {
        target[item] = obj[item];
      }
    }
  }

  /**
   * 通信
   * @method CallApp
   * @param {string} handler 通讯类型： Common 通用、UI 界面、Business 业务、Storage 数据
   * @private
   */
  function CallApp(handler) {
    this.params = {
      handler: handler,
    };

    this.sendMessage = function (data) {
      if (!isApp.scimall && !isApp.scienceChina && !isApp.innovationChina) {
        return;
      }
      // Object.assign(this.params, data);
      extend(this.params, data);

      // 如果是 异步 获取
      if (
        this.params.async ||
        (this.params.parameters && this.params.parameters.async)
      ) {
        var param = this.params;

        if (param.parameters) {
          param.callbackID = param.parameters.callbackId;
          param.callbackFunction = param.parameters.callbackFunction;

          delete param.parameters.async;
          delete param.parameters.callbackId;
          delete param.parameters.callbackFunction;
        } else {
          delete param.async;
        }

        if (platform.android) {
          // android
          return sendSyncMessage(param);
        }
        // ios
        return sendMessage(param);
      } else {
        return sendSyncMessage(this.params);
      }
    };
  }

  // 通用类
  var common = new CallApp("Common");

  // UI类
  var ui = new CallApp("UI");

  // 业务类
  var business = new CallApp("Business");

  // 数据层
  var storage = new CallApp("Storage");

  /**
   * App 状态
   * @method appState
   * @param {String} callbackID: 回调回传id，callbackName：回调方法名
   * @return {Object} { code: 0, } // code  0:点亮屏幕  1:进入后台或锁屏  2:杀掉后台
   * @public
   */
  function appState(callbackId, callbackName) {
    return common.sendMessage({
      action: "AppState",
      callbackID: callbackId,
      callbackFunction: callbackName,
    });
  }

  /**
   * 设置屏幕常亮
   * @method idleTimer
   * @return {Object} { code: 0, } // code: 0 代表成功  1代表不成功
   * @public
   */
  function idleTimer() {
    return common.sendMessage({
      action: "IdleTimer",
    });
  }

  /**
   * 本地输出Log,一般用于配合xcode调试
   * @method  nativeLog
   * @param {String} str 字符串
   * @public
   */
  function nativeLog(str) {
    common.sendMessage({
      action: "NativeLog",
      parameters: str,
    });
  }

  /**
   * 清除缓存
   * @method  clearCache
   * @return {Object} { code: 0 } // 0 代表成功  1代表不成功
   * @public
   */
  function clearCache() {
    return common.sendMessage({
      action: "CleanCache",
    });
  }

  /**
   * 获取token
   * @method  getToken
   * @return {Object} { code: 0, type: 0,  token: 'string' } // code 0 代表成功  1代表不成功, type: 0 游客 1是注册用户
   * @public
   */
  function getToken() {
    return common.sendMessage({
      action: "GetToken",
    });
  }

  /**
   * 调起登录
   * @method  login
   * @return {Object} { code: 0 } // 0 代表成功  1代表不成功
   * @public
   */
  function login() {
    return common.sendMessage({
      action: "StartLogin",
    });
  }

  /**
   * 获取用户信息
   * @method  getUserInfo
   * @return {Object} { code: 0,  data: {} }
   * @public
   */
  function getUserInfo() {
    var params = {
      action: "GetUserInformation",
    };

    return common.sendMessage(params);
  }

  /**
   * 登录身份
   * @method  getUserType
   * @return {Object} { code: 0,  type: 'string' }   type: 0 游客   1 登录用户
   * @public
   */
  function getUserType() {
    return common.sendMessage({
      action: "LoginType",
    });
  }

  /**
   * 获取位置
   * @method  getLocation
   * @param  {String} callbackID: 回调回传id，callbackName：回调方法名
   * @return {Object} { code: 0,  data: {} }
   * @public
   */
  function getLocation(callbackID, callbackName) {
    return common.sendMessage({
      async: true,
      action: "GetLocation",
      callbackID: callbackID,
      callbackFunction: callbackName,
    });
  }

  /**
   * 获取网络状态
   * @method  getNetState
   * @return {Object}  { code: 0,  type: 0-2 } // type 0 无网络  1 移动网络  2 WiFi
   * @public
   */
  function getNetState() {
    return common.sendMessage({
      action: "GetNetState",
    });
  }

  /**
   * 获取设备UUID
   * @method  getNetState
   * @return {Object}  { code: 0,  type: 0-2 } // type 0 无网络  1 移动网络  2 WiFi
   * @public
   */
  function getMobileUUID() {
    return common.sendMessage({
      action: "GetDeviceInfo",
    });
  }

  /**
   * 是否关闭侧滑返回
   * @param {Number} 【isClose=0】  1为关闭侧滑，0开启侧滑
   * @returns
   */
  function sliderClose(isClose = 0) {
    return ui.sendMessage({
      action: "SliderClose",
      parameters: { isClose: isClose },
    });
  }

  /**
   * 隐藏导航栏
   * @method  hideNavBar
   * @return {Object} { code: 0 }
   * @public
   */
  function hideNavBar() {
    return ui.sendMessage({
      action: "HideNaviBar",
    });
  }

  /**
   * 显示导航栏
   * @method  showNavBar
   * @return {Object} { code: 0 }
   * @public
   */
  function showNavBar() {
    return ui.sendMessage({
      action: "ShowNaviBar",
    });
  }

  /**
   * 设置导航栏外观
   * @method  setNavBar
   * @param {Object} params 属性的名称/值 { 'Title': '标题', 'TextColor': 'rgba', 'BackgroundColor': '221,46,49,1' }
   * @return {Object} { code: 0 }
   * @public
   */
  function setNavBar(params) {
    var obj = {
      action: "ConfigNaviBar",
      parameters: params,
    };

    return ui.sendMessage(obj);
  }

  /**
   * 隐藏导航栏按钮
   * @method  hideNavButton
   * @param {Object} params 属性的名称/值 { 'Location' : 'Right/Left' }
   * @return {Object} { code: 0 }
   * @public
   */
  function hideNavButton(params) {
    var obj = {
      action: "HideNaviButton",
      parameters: params,
    };

    return ui.sendMessage(obj);
  }

  /**
   * 显示导航栏按钮
   * @method  showNavButton
   * @param {Object} params 属性的名称/值 { 'Location' : 'Right/Left' }
   * @return {Object} { code: 0 }
   * @public
   */
  function showNavButton(params) {
    var obj = {
      action: "ShowNaviButton",
      parameters: params,
    };

    return ui.sendMessage(obj);
  }

  /**
   * 显示修改按钮
   * @method  showModifyButton
   * @param {Object} params 属性的名称/值 { 'title' : '' }
   * @return {Object} { code: 0 }
   * @public
   *
   * sma.showModifyButton({
   *      title: '修改',
   *      async: true, // 异步
   *      callbackId: 'showPop',
   *      callbackFunction: 'window.showPopFuction',
   * });
   */
  function showModifyButton(params) {
    var obj = {
      action: "RightButtonItem",
      parameters: params,
    };

    return ui.sendMessage(obj);
  }
  /**
   * 禁用/启用 下拉刷新
   * @method  needFreshAction
   * @param {Number} [num=0] 参数： 0 启用刷新  1 禁用刷新
   * @return {Object} { code: 0 }
   * @public
   */
  function needFreshAction(num = 0) {
    var obj = {
      action: "NeedFreshAction",
      parameters: {
        fresh: num,
      },
    };

    return ui.sendMessage(obj);
  }

  /**
   * 关闭窗口
   * @method  closeWindow
   * @public
   */
  function closeWindow() {
    ui.sendMessage({
      action: "CloseWindow",
    });
  }

  /**
   * 跳转原生页面
   * @method  setNativeRouter
   * @param {Number} type 注：1-11 id为必传，其余则不用。
   *          1、发布页面 2、直播 3、科猫小助手 4、视频 5、用户主页 6、会议 7、文章 8、话题列表
   *          9、新鲜事详情 10、部落主页 11、学会主页
   *          12、认证身份信息 13、工作经历 14、教育经历 15、个人标签 16、组织广场（关注组织）
   *          17、进入首页 18、进入社区 19、上传头像 20、添加好友 21、加入兴趣部落
   *          22、签到 23、观看视频列表  24、任务/积分 25、科普中国App站内转发 26、还差一步领收益
   *          27、钱包 28、图集详情(需要传id) 29、专题详情 30、发现  31、签到 32、活动页面
   *          33、组织页面 34、我的页面 35、认证科普员信息 36、我的订单页(科界) 37、提交信息页
   *          38、跳转到日历签到（科普中国）39、积分明细(科普中国) 40、
   * @param {Number} id 要跳转页面的ID
   * @param {Number} indexType 注：1精选 2会议 3动态 4部落 5话题 6活动 7视频 8组织 9H5
   * @param {Boolean} reload 跳转原生页面返回后是否刷新页面 true刷新，false不刷新，默认为 false
   * @example  {
   *               type: 1,
   *               id: 222,
   *               reload: true
   *           }
   * @return {Object} { code: 0 }
   * @public
   */
  function setNativeRouter(options) {
    var obj = {
      action: "Router",
      parameters: options || {},
    };

    switch (options.type) {
      case 1:
        obj.parameters.ViewController = "PostMindViewController";
        break;
      case 2:
        obj.parameters.ViewController = "LiveStreaming";
        break;
      case 3:
        obj.parameters.ViewController = "ScimallAssistant";
        break;
      case 4:
        obj.parameters.ViewController = "VideoDetailViewController";
        break;
      case 5:
        obj.parameters.ViewController = "UserHomePageViewController";
        break;
      case 6:
        obj.parameters.ViewController = "MeetingViewController";
        break;
      case 7:
        obj.parameters.ViewController = "ArticleDetailViewController";
        break;
      case 8:
        obj.parameters.ViewController = "ASCricleTopicListController";
        break;
      case 9:
        obj.parameters.ViewController = "WeiboDetailListViewController";
        break;
      case 10:
        obj.parameters.ViewController = "TribeHomeViewController";
        break;
      case 11:
        obj.parameters.ViewController = "AcademyHomeViewController";
        break;
      case 12:
        obj.parameters.ViewController = "MyAuthenticationViewController";
        break;
      case 13:
        obj.parameters.ViewController = "EditWorkExperienceController";
        break;
      case 14:
        obj.parameters.ViewController = "EduExperienceController";
        break;
      case 15:
        obj.parameters.ViewController = "SettingTagsViewController";
        break;
      case 16:
        obj.parameters.ViewController = "OrganizationController";
        break;
      case 17:
        obj.parameters.ViewController = "SMNaviToHomePage";
        break;
      case 18:
        obj.parameters.ViewController = "SMNaviToCirclePage";
        break;
      case 19:
        obj.parameters.ViewController = "SMUploadAvatar";
        break;
      case 20:
        obj.parameters.ViewController = "SearchFriendViewController";
        break;
      case 21:
        obj.parameters.ViewController = "TribeViewController";
        break;
      case 22:
        obj.parameters.ViewController = "CheckInViewController";
        break;
      case 23:
        obj.parameters.ViewController = "VideoViewController";
        break;
      case 24:
        obj.parameters.ViewController = "TasksViewController";
        break;
      case 25:
        obj.parameters.ViewController = "TransmitViewController"; // 科普中国
        break;
      case 26:
        obj.parameters.ViewController = "GetExpectIncomeListController";
        break;
      case 27:
        obj.parameters.ViewController = "MyWalletViewController";
        break;
      case 28:
        obj.parameters.ViewController = "NewsPictureBrowserController";
        break;
      case 29:
        obj.parameters.ViewController = "FeatureDetailViewController";
        break;
      case 30:
        obj.parameters.ViewController = "SMNaviToDiscoverPage";
        break;
      case 31:
        obj.parameters.ViewController = "SignInViewController";
        break;
      case 32:
        obj.parameters.ViewController = "ActivityViewController";
        break;
      case 33:
        obj.parameters.ViewController = "OrganizationViewController";
        break;
      case 34:
        obj.parameters.ViewController = "MineViewController";
        break;
      case 35:
        obj.parameters.ViewController = "VolunteerApproveViewController";
        break;
      case 36:
        obj.parameters.ViewController = "MyOrderViewController";
        break;
      case 37:
        obj.parameters.ViewController = "SubmitInforViewController";
        break;
      case 38:
        obj.parameters.ViewController = "CalendarViewController";
        break;
      case 39:
        obj.parameters.ViewController = "CoinDetailSubListViewController";
        break;
      case 40: // 科普员省级地图
        obj.parameters.ViewController = "SciencerDetailViewController";
        break;
      case 41: // 个人信息修改
        obj.parameters.ViewController = "EditMySeicnerInfoViewController";
        break;
      case 42: // 参加活动
        obj.parameters.ViewController = "JoinActivityViewController";
        break;
      case 43: // 活动详情 需要id
        obj.parameters.ViewController = "ActivityDetailViewController";
        break;
    }

    if (options.id) {
      obj.parameters.ID = options.id;
    }

    if (options.indexType) {
      obj.parameters.indexType = options.indexType;
    }

    delete obj.parameters.type;
    delete obj.parameters.id;
    // delete obj.parameters.indexType;

    return ui.sendMessage(obj);
  }

  /**
   * 监听 App 返回按钮事件
   * @method  goBack
   * @param {Object} params 属性的名称/值 { 'callbackID': '标题', 'callbackFunction': 'window.goBack' }
   * @example
   * sma.goBack({
   *      callbackID: 'monitor',
   *      callbackFunction: 'window.goBack'
   * })
   * @return {Object} { code: 0 }
   */

  function goBack(params) {
    var obj = {
      action: "GoBack",
      callbackID: params.callbackID,
      callbackFunction: params.callbackFunction,
    };

    return ui.sendMessage(obj);
  }
  /**
   * 设置返回按钮 直接关闭 webview
   * @method  WebBackClose
   */
  function setWebBackClose() {
    var obj = {
      action: "WebBackClose",
      parameters: {
        close: 1,
      },
    };

    return ui.sendMessage(obj);
  }

  /**
   * 写入分享信息
   * @method  setShareInfo
   * @param {Object} params 属性的名称/值 { 'title': '标题', desc: '详情', 'imgUrl': '图片地址', 'link': '链接' }
   * @return {Object} { code: 0 }
   * @example
   * sma.setShareInfo({
   *      title: '标题',
   *      desc: '描述',
   *      imgUrl: '图片',
   *      link: '连接',
   *      async: true, // 异步
   *      callbackId: 'appShare',
   *      callbackFunction: '__base.shareResult',
   *      platform: [1, 2, 3, 4, 5, 6, 7] // // 1:社区 2:朋友圈 3:微信好友 4:科界好友 5:新浪微博 6:QQ 7:系统分享 20: 复制连接
   * });
   * @public
   */
  function setShareInfo(params) {
    var obj = {
      action: "TransShareInfo",
      parameters: params,
    };

    return business.sendMessage(obj);
  }

  /**
   * 调起分享
   * @method  share
   * @param {Object} params 属性的名称/值 { 'title': '标题', desc: '详情', 'imgUrl': '图片地址', 'link': '链接' }
   * @return {Object} { code: 0, type: string } // type 分享的类型 QQ\WeChat等等
   * @example
   * sma.setShareInfo({
   *      title: '标题',
   *      desc: '描述',
   *      imgUrl: '图片',
   *      link: '连接',
   *      async: true, // 异步
   *      callbackId: 'appShare',
   *      callbackFunction: '__base.shareResult',
   *      platform: [1, 2, 3, 4, 5, 6, 7] // // 1:社区 2:朋友圈 3:微信好友 4:科界好友 5:新浪微博 6:QQ 7:系统分享
   * });
   * @public
   */
  function share(params) {
    var obj = {
      action: "Share",
      parameters: params,
    };

    return business.sendMessage(obj);
  }

  /**
   * APP 内获取微信授权
   * @method getWeChatAttention
   */
  function getWeChatAttention() {
    var obj = {
      action: "WechatAttention",
    };

    return business.sendMessage(obj);
  }

  /**
   * 赏金计划分享
   * @method rewardPlan
   * @param {Number} num 1 代表首次进入   2 代表点击发生
   * @return {Object} { code: 0, data: { 'name': 'xxx', 'value': 'xxxx' } }
   * @public
   */
  function rewardPlan(num) {
    var obj = {
      action: "RewardPlan",
      parameters: {
        type: num,
      },
    };

    return business.sendMessage(obj);
  }

  /**
   * 科普号点击关注状态切换
   * @method scienceCornerAction
   * @param {Number} isCorner // 0 未关注  1 已关注
   * @return {Object}
   * @example
   * sma.scienceCornerAction({
   *      isCorner: 0, // or 1
   *      callbackID: 'id',
   *      callbackFunction: __base.callbackFunction,
   * });
   */
  function scienceCornerAction(params) {
    var obj = {
      action: "scienceNumberCornerAction",
      parameters: {
        isCorner: params.isCorner,
      },
      callbackID: params.callbackID,
      callbackFunction: params.callbackFunction,
    };

    return business.sendMessage(obj);
  }

  /**
   * 科普号点击跳转到科普号主页
   * @method scienceNumberHomePageAction
   * @param {Number} scienceNumberId
   */
  function scienceNumberHomePageAction(scienceNumberId) {
    var obj = {
      action: "scienceNumberHomePageAction",
      parameters: {
        scienceNumberId: scienceNumberId,
      },
    };

    return business.sendMessage(obj);
  }

  /**
   * 显示科普员地图规则
   * @method scienceNumberHomePageAction
   * @param {Number} scienceNumberId
   */
  function showMapHelp(params) {
    var obj = {
      action: "showMapHelp",
      parameters: {
        path: params.url,
      },
    };
    console.log(obj);
    return business.sendMessage(obj);
  }

  /**
   * 获取签名
   * @method getSN
   * @param {Object} params { url: '/api/xxx', data: {name: 'li'} } // data 不是必填
   * @return {Object} { code: 0, data: { 'name': 'xxx', 'value': 'xxxx' } }
   * @public
   */
  function getSN(params) {
    var obj = {
      action: "GetSnStr",
      parameters: {
        path: params.url,
      },
    };

    if (params.data) {
      var data = params.data;

      for (var name in data) {
        obj.parameters[name] = data[name];
      }
    }

    return business.sendMessage(obj);
  }

  /**
   * Native 控制原生返回按钮跳转
   * @method webBackUrl
   * @param {String} strUrl 网址
   * @return {Object} { code: 0  }
   * @public
   */
  function webBackUrl(strUrl) {
    return business.sendMessage({
      action: "WebBackUrl",
      parameters: {
        backUrl: strUrl,
      },
    });
  }

  /**
   * Native 写入本地存储
   * @method setStorage
   * @param {Object} params 属性的名称/值 { key: '数据名称', value: '数据' }
   * @return {Object} { code: 0 }
   * @public
   */
  function setStorage(params) {
    return storage.sendMessage(
      Object.assign({
        action: "KeyValueWrite",
        parameters: params,
      })
    );
  }

  /**
   * Native 读取本地存储
   * @method getStorage
   * @param {String} name 数据名称
   * @return {Object} { code: 0, data: { 'name': 'xxx', 'value': 'xxxx' } }
   * @public
   */
  function getStorage(name) {
    return storage.sendMessage(
      Object.assign({
        action: "KeyValueRead",
        parameters: {
          Key: name,
        },
      })
    );
  }

  /**
   * Native app设置webview高度
   */
  function editHeightAction(height) {
    return ui.sendMessage(
      Object.assign({
        action: "EditHeight",
        parameters: {
          height: height,
        },
      })
    );
  }

  /**
   * web 获取编辑内容的方法
   */
  function reEditContent(params) {
    var obj = {
      action: "ReEditContent",
      parameters: {},
    };

    var newObj = Object.assign({}, obj, params);

    return ui.sendMessage(newObj);
  }

  /**
   * web 通知app跳转编辑页
   */
  function reEditContentAction() {
    var obj = {
      action: "ReEditContentAction",
      parameters: {},
    };

    return ui.sendMessage(obj);
  }

  /**
   * 科普号详情页 通知app显示弹窗
   * @method joinActivityAction
   * @param {Number} scienceNumberId
   */
  function joinActivityAction(id) {
    var obj = {
      action: "joinActivityAction",
      parameters: {
        scienceNumberId: id,
      },
    };

    return business.sendMessage(obj);
  }

  /**
   * 科普号详情页 通知app点击的是哪个选项
   * @method segmentAction
   * @param {Number} index
   */
  function segmentAction(index) {
    var obj = {
      action: "segmentAction",
      parameters: {
        index: index,
      },
    };

    return business.sendMessage(obj);
  }

  /**
   * web向app获取科普日活动内容
   */
  function scienceActEditAction(params) {
    var obj = {
      action: "ScienceActEditAction",
      parameters: {},
    };

    var newObj = Object.assign({}, obj, params);

    return ui.sendMessage(newObj);
  }

  /**
   * web向app获取科普日比赛简介内容
   */
  function scienceActGameEditAction(params) {
    var obj = {
      action: "ScienceActGameEditAction",
      parameters: {},
    };

    var newObj = Object.assign({}, obj, params);

    return ui.sendMessage(newObj);
  }

  // 线上参与活动
  function onlineJoinActivity(params) {
    var r = {
      action: "OnlineJoinActivity",
      parameters: { status: params.status },
      callbackID: params.callbackID,
      callbackFunction: params.callbackFunction,
    };
    return business.sendMessage(r);
  }

  // 线下报名活动
  function offlineSignUpActivity(params) {
    var r = {
      action: "OfflineSignUpActivity",
      parameters: { status: params.status },
      callbackID: params.callbackID,
      callbackFunction: params.callbackFunction,
    };
    return business.sendMessage(r);
  }

  var sma = {
    name: "sma.js",
    version: "0.0.1",
    platform: platform,
    isApp: isApp,
    appState: appState,
    idleTimer: idleTimer,
    nativeLog: nativeLog,
    getToken: getToken,
    login: login,
    share: share,
    getWeChatAttention: getWeChatAttention,
    setShareInfo: setShareInfo,
    getUserInfo: getUserInfo,
    clearCache: clearCache,
    getLocation: getLocation,
    getNetState: getNetState,
    getMobileUUID: getMobileUUID,
    getUserType: getUserType,
    sliderClose: sliderClose,
    hideNavBar: hideNavBar,
    showNavBar: showNavBar,
    setNavBar: setNavBar,
    hideNavButton: hideNavButton,
    showNavButton: showNavButton,
    showModifyButton: showModifyButton,
    needFreshAction: needFreshAction,
    closeWindow: closeWindow,
    setNativeRouter: setNativeRouter,
    webBackUrl: webBackUrl,
    getSN: getSN,
    showMapHelp: showMapHelp,
    setStorage: setStorage,
    getStorage: getStorage,
    rewardPlan: rewardPlan,
    goBack: goBack,
    setWebBackClose: setWebBackClose,
    scienceCornerAction: scienceCornerAction,
    scienceNumberHomePageAction: scienceNumberHomePageAction,
    editHeightAction: editHeightAction,
    reEditContent: reEditContent,
    reEditContentAction: reEditContentAction,
    joinActivityAction: joinActivityAction,
    segmentAction: segmentAction,
    scienceActEditAction: scienceActEditAction,
    scienceActGameEditAction: scienceActGameEditAction,
    onlineJoinActivity: onlineJoinActivity,
    offlineSignUpActivity: offlineSignUpActivity,
  };

  window.sma = sma;

  return sma;
});
